import { I18n } from 'common/i18n';
import { FilterScope, getScope } from './translations';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { SelectDropdownConfig } from './filter-config';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { FilterType, SelectOption } from './types';

export const getSourceOptions = (sources: string[]): SelectOption[] => {
  const scope = getScope(FilterScope.Source);

  const mappedSources = sources.map((source: string) => ({ label: source, value: source }));
  mappedSources.unshift({ label: I18n.t('options.all', { scope }), value: '' });

  return mappedSources;
};

export const sourceConfigs: SelectDropdownConfig = {
  filterName: Filters.Source,
  label: I18n.t('label', { scope: getScope(FilterScope.Source) }),
  getOptions: (list: string[]) => getSourceOptions(list),
  dispatchAction: filters.changeSource,
  filterType: FilterType.SelectDropdown,
};
